<template>
  <div id="warranty_content">
    <van-nav-bar
      title="工程日历"
      left-text="返回"
      :right-text="rightContent"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <van-tabs @click="changeCalendar">
      <van-tab title="订单日历">
        <van-calendar
          :poppable="false"
          :show-confirm="false"
          :formatter="formatter"
          :style="{ height: '400px' }"
          @select="selectDate"
        />
        <div v-if="details.length > 0">
          <div style="text-align: left;margin-left: 16px; margin-top: 4px; margin-bottom: 2px;">工作行程</div>
          <div class="van-cell-group van-cell-group--inset van-hairline--top-bottom" style="margin-bottom: 10px;">
            <div class="van-cell" v-for="(item, index) in details" @click="forwardPage(item)">
              <div class="van-cell__title" style="text-align: left;"><span>{{ item.ma_cate_cn }}</span></div>
              <div class="van-cell__value" style="text-align: right;"><span>上门时间: {{ item.ma_start_to_end }}</span></div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="工作计划">
        <van-calendar
          :poppable="false"
          :show-confirm="false"
          :formatter="formatterTips"
          :style="{ height: '400px' }"
          @select="selectTipDate"
        />
        <van-cell is-link @click="showPopup">新增计划</van-cell>
        <van-popup
          v-model="show"
          :style="{ height: '100%', width: '100%' }"
        >
          <div style="margin-top: 40px;"></div>
          <van-field
            readonly
            clickable
            name="picker"
            :value="addForm.city_cn"
            label="城市"
            placeholder="城市"
            @click="showCityPicker = true"
          />
          <van-popup v-model="showCityPicker" position="bottom">
            <van-picker
              title="请选择城市"
              show-toolbar
              :columns="cityList"
              value-key="city_cn"
              @confirm="onConfirmCity"
              @cancel="onCancelCity"
              @change="onChangeCity"
              :default-index="addForm.city_id"
            />
          </van-popup>
          <van-field
            readonly
            clickable
            name="picker"
            :value="addForm.brand_en"
            label="品牌"
            placeholder="品牌"
            @click="showBrandPicker = true"
          />
          <van-popup v-model="showBrandPicker" position="bottom">
            <van-picker
              title="请选择品牌"
              show-toolbar
              :columns="brandsList"
              value-key="brand_en"
              @confirm="onConfirmBrand"
              @cancel="onCancelBrand"
              @change="onChangeBrand"
              :default-index="addForm.brand_id"
            />
          </van-popup>
          <van-field
            readonly
            clickable
            name="picker"
            :value="addForm.market_cn"
            label="商场"
            placeholder="商场"
            @click="showMarketPicker = true"
          />
          <van-popup v-model="showMarketPicker" position="bottom">
            <van-picker
              title="请选择商场"
              show-toolbar
              :columns="marketList"
              value-key="market_cn"
              @confirm="onConfirmMarket"
              @cancel="onCancelMarket"
              @change="onChangeMarket"
              :default-index="addForm.market_id"
            />
          </van-popup>
          <van-field
            v-model="addForm.store_cn"
            name="店铺名"
            label="店铺名"
            placeholder="店铺名"
            readonly
            @click="showStorePicker = true"
            :rules="[{ required: true, message: '店铺名' }]"
          />
          <van-popup v-model="showStorePicker" position="bottom">
            <van-picker
              title="请选择店铺名"
              show-toolbar
              :columns="storeList"
              value-key="name_cn"
              @confirm="onConfirmStore"
              @cancel="onCancelStore"
              @change="onChangeStore"
              :default-index="addForm.store_id"
            />
          </van-popup>
          <van-field v-model="addForm.title" type="text" label="标题" />
          <van-field v-model="addForm.content"
                     type="textarea"
                     rows="2"
                     autosize
                     label="备注" />
          <van-field
            readonly
            clickable
            name="picker"
            :value="addForm.typeCn"
            label="维修类型"
            placeholder="维修类型"
            @click="showTypePicker = true"
          />
          <van-popup v-model="showTypePicker" position="bottom">
            <van-picker
              title="请选择维修类型"
              show-toolbar
              :columns="columns"
              @confirm="onConfirm"
              @cancel="onCancel"
              @change="onChange"
              :default-index="addForm.type"
              :rules="[{ required: true, message: '维修类型' }]"
            />
          </van-popup>
          <van-cell title="开始时间" :value="addForm.start_at" style="text-align: left;" @click="showRepairStartTime = true" />
          <van-popup v-model="showRepairStartTime" position="bottom">
            <van-datetime-picker
              type="datehour"
              title="开始时间"
              :min-date="minDate"
              @cancel="showRepairStartTime = false"
              @confirm="selectStartDate"
            />
          </van-popup>
          <van-cell title="结束时间" :value="addForm.end_at" style="text-align: left;" @click="showRepairEndTime = true" />
          <van-popup v-model="showRepairEndTime" position="bottom">
            <van-datetime-picker
              type="datehour"
              title="结束时间"
              :min-date="minDate"
              @cancel="showRepairEndTime = false"
              @confirm="selectEndDate"
            />
          </van-popup>
          <div style="margin-top: 20px;">
            <van-button type="info" style="width: 80px; height: 35px; border-radius: 5px;float: left;margin-top: 20px; margin-left: 80px;" @click="cancel">取消</van-button>
            <van-button type="primary" style="width: 80px; height: 35px; border-radius: 5px;float: left;margin-top: 20px; margin-left: 30px;" @click="submit">提交</van-button>
          </div>
        </van-popup>
        <div v-if="tipDetails.length > 0">
          <div style="text-align: left;margin-left: 16px; margin-top: 4px; margin-bottom: 2px;">工作行程</div>
          <div class="van-cell-group van-cell-group--inset van-hairline--top-bottom" style="margin-bottom: 10px;">
            <div class="van-cell" v-for="(item, index) in tipDetails" @click="forwardTips(item)">
              <div class="van-cell__title" style="text-align: left;"><span>{{ item.store_cn  + ' ' + (typeof item.title !== 'undefined' ? item.title : '') }}</span></div>
              <div class="van-cell__value" style="text-align: right;"><span>时间: {{ item.work_start_to_end_mini }}</span></div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import {
  getBrandList,
  getCityList,
  getMarketList,
  getShopList,
  getWorkingByDate,
  getWorkingCalendar
} from "../../api/order";
import {createOrUpdateWorkerTipsItem, getTipListByDate, getTipsCalendar} from "../../api/calendar";
import {Toast} from "vant";

export default {
  name: 'orderCalendar',
  data () {
    return {
      checkedValue: [],
      columns: ['普通', '紧急'],
      rightContent: '',
      minDate: '',
      show: false,
      workers: [],
      details: [],
      tipDetails: [],
      dateList: [],
      result: [],
      showCityPicker: false,
      showTypePicker: false,
      showRepairStartTime: false,
      showSelectWorker: false,
      showMarketPicker: false,
      showBrandPicker: false,
      showStorePicker: false,
      showRepairEndTime: false,
      marketList: [],
      cityList: [],
      brandsList: [],
      storeList: [],
      addForm: {},
      addLoading: false,
      tipDateList: []
    }
  },
  created () {
    this.initDate()
    this.initData()
    this.initCity()
    this.initBrand()
  },
  methods: {
    forwardTips(item) {
      this.show = true
      this.addForm = item
    },
    selectTipDate(date) {
      this.getTipListByDate(this.GMTToStr(date))
    },
    getTipListByDate(date) {
      getTipListByDate({ date: date }).then((res) => {
        console.log('res......', res.date)
        if (res.data) {
          this.tipDetails = res.data.data
        }
      })
    },
    getTipsDate() {
      getTipsCalendar().then((res) => {
        console.log('res........', res)
        if (res.data.data) {
          this.tipDateList = res.data.data
        }
      })
    },
    onConfirm (val, index) {
      this.addForm.typeCn = val
      this.addForm.type = index
      this.showTypePicker = false
    },
    onCancel (val) {
      this.showTypePicker = false
    },
    submit() {
      if (this.addLoading) {
        Toast('提交中，请耐心等待')
        return false
      }
      const data = JSON.parse(JSON.stringify(this.addForm))
      if (this.addForm.start_at) {
        data.work_start_at = this.addForm.start_at
      }
      if (this.addForm.end_at) {
        data.work_end_at = this.addForm.end_at
      }
      data.type = this.addForm.typeCn
      this.addLoading = true
      createOrUpdateWorkerTipsItem(data).then((res) => {
        if (res.data.code == 0) {
          this.addLoading = false
          Toast('保存成功')
          this.getTipsDate()
          this.getTipListByDate(this.GMTToStr(new Date()))
          this.show = false
        }
      })
    },
    cancel() {
      this.show = false
      this.addForm = {}
    },
    selectStartDate (val) {
      this.showRepairStartTime = false;
      this.addForm.start_at = this.formatDateHour(val);
    },
    selectEndDate (val) {
      this.showRepairEndTime = false;
      this.addForm.end_at = this.formatDateHour(val)
    },
    formatDateHour(date) {
      return  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:00`;
    },
    onCancelBrand() {
      this.showBrandPicker = false
    },
    onConfirmBrand(evt) {
      this.addForm.brand_id = evt.id
      this.addForm.brand_en = evt.brand_en
      this.showBrandPicker = false
      this.searchStore()
    },
    onConfirmMarket(evt) {
      this.addForm.market_id = evt.id
      this.addForm.market_cn = evt.market_cn
      this.addForm.store_id = ''
      this.addForm.shop_name = ''
      this.showMarketPicker = false
      this.searchStore()
    },
    onFailed() {

    },
    onChangeBrand() {

    },
    onConfirmCity(evt) {
      this.addForm.city_id = evt.id
      this.addForm.city_cn = evt.city_cn
      this.showCityPicker = false
      this.initMarkets()
      this.searchStore()
    },
    onChangeCity(evt) {
      console.log(evt)
    },
    onCancelCity() {
      this.showCityPicker = false
    },
    initMarkets() {
      getMarketList({city_id: this.addForm.city_id}).then((res) => {
        if (res.data.data) {
          this.marketList = res.data.data
        }
      })
    },
    initCity() {
      getCityList().then((res) => {
        if (res.data.data) {
          console.log('cityList.....', this.cityList)
          this.cityList = res.data.data
        }
      })
    },
    initBrand() {
      getBrandList().then((res) => {
        if (res.data.data) {
          this.brandsList = res.data.data
        }
      })
    },
    showPopup() {
      this.show = true
    },
    changeCalendar(name, title) {
      console.log('name......title', name, title)
      if (title === '工作计划') {
        this.getTipsDate()
        this.getTipListByDate(this.GMTToStr(new Date()))
      }
    },
    initDate() {
      this.minDate = new Date()
    },
    forwardPage(event) {
      console.log('event......', event)
      if (event.appo_task_id) {
        this.$router.push({path: '/warranty_detail', query: {appo_task_id: event.appo_task_id, ma_item_id: event.ma_item_id}})
      }
    },
    formatterTips(day) {
      const date = day;
      if (this.tipDateList.length <= 0) {
        return date
      }
      const date1 = this.formatDate(date.date);//将日期转为字符串
      for (let nowDay of this.tipDateList) {
        if (nowDay === date1) {
          date.bottomInfo = '计划安排'
          date.className = "red-flag";
        }
      }
      return date
    },
    formatter(day) {
      const date = day;
      if (this.dateList.length <= 0) {
        return date
      }
      const date1 = this.formatDate(date.date);//将日期转为字符串
      for (let nowDay of this.dateList) {
        if (nowDay === date1) {
          date.bottomInfo = '待维修'
          date.className = "red-flag";
        }
      }
      return date
    },
    selectDate(date) {
      getWorkingByDate({date: this.GMTToStr(date)}).then((res) => {
        console.log("res.....", res.data.data)
        if (res.data.data) {
          this.details = res.data.data
        }
      })
      /*maintenanceRecords(this.GMTToStr(date)).then((res) => {
        if (res.data.data) {
          this.details = res.data.data
        }
      })*/
    },
    initData() {
      getWorkingCalendar().then((res) => {
        if (res.data.data) {
          console.log('data.......', res.data.data)
          this.result = res.data.data
          this.dateList = res.data.data
        }
      })
      this.selectDate(new Date())
    },
    onChangeStore() {

    },
    onChangeMarket() {

    },
    onCancelMarket() {
      this.showMarketPicker = false
    },
    onCancelStore() {
      this.showStorePicker = false
    },
    searchStore() {
      getShopList({city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id}).then((res) => {
        if (res.data.data) {
          this.storeList = res.data.data
        }
      })
    },
    onConfirmStore(evt) {
      this.addForm.store_id = evt.id
      this.addForm.store_cn = evt.name_cn
      this.showStorePicker = false
      console.log('evt......', evt)
    },
    GMTToStr(time) {
      let date = new Date(time)
      let Str=date.getFullYear() + '-' +
        (this.handleTimeStr(date.getMonth() + 1)) + '-' +
        this.handleTimeStr(date.getDate())
      return Str
    },
    handleTimeStr(tStr) {  // 解决 10:2:2 出现各位数字格式化为 10:02:02
      if (tStr < 10){
        return '0'+ tStr
      }else {
        return tStr
      }
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    onChange (picker, values) {
      console.log(picker, values)
    },
    formatDate(date) {
      let day = date.getFullYear();
      day += '-' + (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1));
      day += '-' + (date.getDate() >= 10 ? date.getDate() : '0' + date.getDate());
      return  day;
    },
    onClickRight () {
      if (this.$route.query.id) {
        this.$router.push({path: '/warranty_report', query: {id: this.$route.query.id, annex_id: this.$route.query.annex_id }})
      }
    },
  }
}
</script>

<style>
  .red-flag {
    /*background-color: red;
    color:#ffffff;
    border-radius: 4px;*/
  }
  .van-calendar__selected-day {
    /*background-color: red !important;*/
  }
  .van-calendar__selected-day .van-calendar__bottom-info { color: #ffffff !important; }
  .van-calendar__bottom-info { color: red !important; }
  .van-calendar__header-title { display: none !important; }
</style>



// WEBPACK FOOTER //
// src/views/order/calendar.vue